import React from 'react';
import Test from './test';
import Empty from './empty';
import SEO from './seo';
import QuickLinks from './quickLinks';
import HeroMarketingBanner from './heroMarketingBanner';
import MarketingBanner from './marketingBanner';
import SwimlineContent from './swimlineContent';
import SwimlineListContent from './swimlineListContent';
import HeroVideo from './heroVideo';
import TextImageBanner from './textImageBanner';
import TextMediaBanner from './textMediaBanner';
import VideoBanner from './videoBanner';
import LinksList from './linksList';
import GeneralBanner from './generalBanner';
import { useBanners } from '../../hooks';

export default function PageManagement({ type, ...rest }) {

  const {
    disciplines,
    ageGrades,
    sectors,
  } = useBanners();

  let comp = <div></div>;
  switch (type) {
    case 'test':
      comp = <Test {...rest} />
      break;
    case 'empty':
      comp = <Empty {...rest} />
      break;
    case 'seo':
      comp = <SEO {...rest} />
      break;
    case 'quickLinks':
      comp = <QuickLinks {...rest} />
      break;
    case 'heroMarketingBanner':
      comp = <HeroMarketingBanner {...rest} />
      break;
    case 'marketingBanner':
      comp = <MarketingBanner {...rest} />
      break;
    case 'swimlineContent':
      comp = <SwimlineContent {...rest} />
      break;
    case 'swimlineListContent':
      comp = <SwimlineListContent {...rest} />
      break;
    case 'heroVideo':
      comp = <HeroVideo {...rest} />
      break;
    case 'textImageBanner':
      comp = <TextImageBanner {...rest} />
      break;
    case 'textMediaBanner':
      comp = <TextMediaBanner {...rest}
        ageGradesList={ageGrades}
        disciplinesList={disciplines}
        sectorsList={sectors}
      />
      break;
    case 'videoBanner':
      comp = <VideoBanner {...rest} />
      break;
    case 'linksList':
      comp = <LinksList {...rest} />
      break;
    case 'generalBanner':
      comp = <GeneralBanner {...rest} />
      break;
    default:
      break;
  }

  return <div>{comp}</div>;
};